export default {
  install(Vue) {
    Vue.prototype.$constants = () => {
      return {
        VERSION: '1.0.0',

        equipoTrabajoTableFields: [

          { key: 'categoriaConsultor', label: 'Consultor',  thStyle: { width: '40px', heigth: '80px', textAlign: 'center', verticalAlign: 'middle' } },
          { key: 'consultorNombre.nombre', label: 'Nombre',  thStyle: { width: '260px', textAlign: 'center' }, tdStyle: { verticalAlign: 'middle' } },

          { key: 'horasEstimadas', label: 'Horas Estimadas',  thStyle: { width: '80px', textAlign: 'center' }, tdStyle: { verticalAlign: 'middle' } },
          { key: 'horasRealesConsultor', label: 'Horas Reales',  thStyle: { width: '80px', textAlign: 'center' }, tdStyle: { verticalAlign: 'middle' } },
          { key: 'desviacionHoras', label: 'Desviación Horas',  thStyle: { width: '80px', textAlign: 'center' }, tdStyle: { verticalAlign: 'middle' } },
          { key: 'facturacionConsultorPorcentaje', label: 'Facturacion Consultor %', thStyle: { width: '80px', textAlign: 'center' }, tdStyle: { verticalAlign: 'middle' } },
          { key: 'action', label: '', thStyle: { width: '30px' }, tdStyle: { verticalAlign: 'middle' } }

        ],

        avanceItemTableFields: [

          { key: 'fechaAvance', label: 'Fecha', thStyle: { width: '150px', verticalAlign: 'middle', textAlign: 'center' } },
          // { key: 'horasRealesEquipoTrabajo', label: 'Horas Reales Total', sortable: true , thStyle: { width: '40px', verticalAlign: 'middle',textAlign:'center' } },
          // { key: 'avanceHoras', label: '% Avance Horas', sortable: true, thStyle: { width: '40px', verticalAlign: 'middle',textAlign:'center' } },
          { key: 'avancePropietario', label: '% Avance Propietario', thStyle: { width: '100px', verticalAlign: 'middle', textAlign: 'center' } },
          { key: 'comentariosAvance', label: 'Comentarios',  thStyle: { width: '350px', verticalAlign: 'middle', textAlign: 'center' } },

          { key: 'importeEjecutado', label: 'Importe Ejecutado',  thStyle: { width: '40px', verticalAlign: 'middle', textAlign: 'center' } },
          { key: 'importeProvisionado', label: 'Importe Provisionado',  thStyle: { width: '40px', verticalAlign: 'middle', textAlign: 'center' } },
          { key: 'provisionado', label: 'Provisionado',  thStyle: { width: '80px', verticalAlign: 'middle', textAlign: 'center' } },
          { key: 'action', label: '', thStyle: { width: '30px', verticalAlign: 'middle', textAlign: 'center' } },

        ],
        hitoEntregaTableFields: [
          { key: 'fechaCreacion', label: 'Fecha Creación',  thStyle: { width: '150px', verticalAlign: 'middle', textAlign: 'center' } },
          { key: 'fechaEntrega', label: 'Nueva Fecha Entrega',  thStyle: { width: '150px', verticalAlign: 'middle', textAlign: 'center' } },
          { key: 'comentario', label: 'Comentario',  thStyle: { width: '400px', verticalAlign: 'middle', textAlign: 'center' } },
          { key: 'action', label: '', thStyle: { width: '30px', verticalAlign: 'middle', textAlign: 'center' } },
        ],
        horasTableFields: [

          //{ key: 'centro', label: 'Centro', sortable: true },
          { key: 'action', label: '', thStyle: { width: '120px' } }
        ],
        projectsTableFields: [
          { key: 'lock', label: '', class: 'text-center', thStyle: { width: '36px' } },
          { key: 'cliente.nombre', label: 'Cliente', sortable: true },
          { key: 'numeroOferta', label: 'Numero Oferta', sortable: true },
          { key: 'nombreOferta', label: 'Nombre Oferta', sortable: true },
          { key: 'propietario.nombre', label: 'Propietario', sortable: true },

          //  { key: 'itemsProject[0].fechaPedido', label: 'Fecha Pedido', sortable: true },

          { key: 'estado', label: 'Estado', sortable: true },
          { key: 'action', label: '', thStyle: { width: '120px' } }
        ],
        cursosAmazonTableFields: [
          { key: 'batchName', label: 'BatchName', sortable: true },
          { key: 'tipoCurso', label: 'Tipo Curso', sortable: true },

          { key: 'startDate', label: 'Fecha / Hora', sortable: true },
          { key: 'estado', label: 'Estado', sortable: true },
          { key: 'facturado', label: 'Facturado', sortable: true },
          { key: 'action', label: '', thStyle: { width: '120px' } }

        ],
        projectsFinishedTableFields: [

          //{ key: 'centro', label: 'Centro', sortable: true },
          { key: 'cliente', label: 'Fecha Entrega', sortable: true },
          { key: 'numeroOferta', label: 'Numero Oferta', sortable: true },
          { key: 'nombreOferta', label: 'Nombre Oferta', sortable: true },
          { key: 'propietario.nombre', label: 'Propietario', sortable: true },
          { key: 'fechaPedido', label: 'Fecha Pedido', sortable: true },

          { key: 'estado', label: 'Estado', sortable: true },
          { key: 'action', label: '', thStyle: { width: '120px' } }
        ],
        projectsStateTableFields: [

          //{ key: 'centro', label: 'Centro', sortable: true },
          { key: 'cliente', label: 'Fecha Entrega', sortable: true },
          { key: 'numeroOferta', label: 'Numero Oferta', sortable: true },
          { key: 'nombreOferta', label: 'Nombre Oferta', sortable: true },
          { key: 'propietario.nombre', label: 'Propietario', sortable: true },
          { key: 'fechaPedido', label: 'Fecha Pedido', sortable: true },

          { key: 'estado', label: 'Estado', sortable: true },
          { key: 'action', label: '', thStyle: { width: '120px' } }
        ],
        itemTableFields: [

          { key: 'descripcion', label: this.opnTraining ? 'Cliente' : 'Descripcion', sortable: true },
          { key: 'numeroItem', label: 'Numero Item', sortable: true },
          { key: 'fechaEntrega', label: 'FechaEntrega', sortable: true },
          { key: 'horasEstimadasTotal', label: 'Horas Estimadas', sortable: true },
          //  { key: 'equipoTrabrajo.horasRealesEquipoTrabajo', label: 'Horas Reales', sortable: true },
          { key: 'importeItem', label: 'Importe', sortable: true },


          { key: 'action', label: '', thStyle: { width: '120px' } }
        ],
        safetySessions: [

          { key: 'batchName', label: 'BatchName', sortable: true },
          { key: 'razonSocial', label: 'Razon Social', sortable: true },
          { key: 'importeTotalCursoSafety', label: 'importeTotalCursoSafety', sortable: true },


          { key: 'action', label: '', thStyle: { width: '120px' } }
        ],
        hitosFacturacionFields: [

          { key: 'hitoFacturacion', label: 'Hito',  thStyle: { width: '80px', textAlign: 'center' } },
          { key: 'importeHito', label: 'Importe',  thStyle: { width: '80px', textAlign: 'center' } },
          { key: 'facturarConsultor', label: 'Consultor/ Facturar?',  thStyle: { width: '80px', textAlign: 'center' } },
          { key: 'fechaOKConsultor', label: 'Fecha',  thStyle: { width: '110px', textAlign: 'center' } },

          { key: 'hitoFacturado', label: 'Facturado',  thStyle: { width: '40px', textAlign: 'center' } },
          { key: 'fechaFacturado', label: 'Fecha',  thStyle: { width: '80px', textAlign: 'center' } },
          { key: 'numFactura', label: 'Nº Factura', thStyle: { width: '230px', textAlign: 'center' } },

          { key: 'liquidarNumeroDocumento', label: 'Nº Factura Liquida',  thStyle: { width: '230px', textAlign: 'center' } },

          { key: 'action', label: '', thStyle: { width: '30px', textAlign: 'center' } }
        ],
        provisionItemTableFields: [


          { key: 'importeProvisionado', label: 'Importe Provisionado',  thStyle: { width: '150px', textAlign: 'center' } },

          { key: 'fechaProvisionado', label: 'Fecha Provision',  thStyle: { width: '220px', textAlign: 'center' } },

          { key: 'facturadoProvision', label: 'Facturado',  thStyle: { width: '200px', textAlign: 'center' } },
          { key: 'fechaFacturadoProvision', label: 'Fecha Facturado Provisión',  thStyle: { width: '260px', textAlign: 'center' } },
          { key: 'action', label: '', thStyle: { width: '30px' } }
        ],
        optionsTipoProyectoEsp: [
          {
            value: 'Descarbonización',
            text: 'Descarbonización'
          },
          {
            value: 'Sostenibilidad Activos Inmobiliarios',
            text: 'Sostenibilidad Activos Inmobiliarios'
          },
          {
            value: 'Consultoría Ambiental',
            text: 'Consultoría Ambiental'
          },
          {
            value: 'Estrategia ESG',
            text: 'Estrategia ESG'
          },
          {
            value: 'Accidentes graves - SEVESO',
            text: 'Accidentes graves - SEVESO'
          },

          {
            value:
              'ATEX (Clasificación de zonas/Evaluación de riesgos de explosión/Inspección de equipos)',
            text:
              'ATEX (Clasificación de zonas/Evaluación de riesgos de explosión/Inspección de equipos)'
          },
          { value: 'PSM-OPS', text: 'PSM-OPS' },
          {
            value: 'CRH-Vent sizing',
            text: 'CRH-Vent sizing'
          },

          {
            value: 'Ensayo',
            text: 'Ensayo'
          },
          { value: 'Formación', text: 'Formación' },
          {
            value: 'Occupational safety',
            text: 'Occupational safety'
          },

          { value: 'PHA', text: 'PHA' },


          {
            value: 'Seguridad Funcional - SIL',
            text: 'Seguridad Funcional - SIL'
          },

          {
            value: 'Consultoría en transporte y logística',
            text: 'Consultoría en transporte y logística'
          },
          {
            value: 'Seguridad de máquinas-activos',
            text: 'Seguridad de máquinas-activos'
          },
          {
            value: 'OSR',
            text: 'OSR'
          },

          { value: 'Otro', text: 'Otro' }
        ],
        optionsClaseProyectoESP: [
          { text: 'Formación', value: 'TRAINING' },
          { text: 'Consultoría', value: 'CONSULTING' },
          { text: 'Ensayos', value: 'TESTING' },
          { text: 'Open Training', value: 'OPENTRAINING' },
          { text: 'E-Learning', value: 'ELEARNING' },
        ],
        optionsSectoresEsp: [
          { value: "Administración pública", text: "Administración pública" },
          { value: "Automoción", text: "Automoción" },
          { value: "Aeroespacial y Defensa", text: "Aeroespacial y Defensa" },
          { value: "Bienes de consumo", text: "Bienes de consumo" },
          { value: "Consultores", text: "Consultores" },
          { value: "Cosmética", text: "Cosmética" },
          { value: "Energía / Servicios / Residuos", text: "Energía / Servicios / Residuos" },
          { value: "EPC", text: "EPC" },
          { value: "Fabricantes de equipos", text: "Fabricantes de equipos" },
          { value: "Farmacéutico", text: "Farmacéutico" },
          { value: "Industria Papelera/Celulosa", text: "Industria Papelera/Celulosa" },
          { value: "Materiales de construcción / Vidrio", text: "Materiales de construcción / Vidrio" },
          { value: "Oil & Gas", text: "Oil & Gas" },
          { value: "Químico", text: "Químico" },
          { value: "Otros", text: "Otros" },
        ],
        optionsCondicionesPago: [
          { text: '30-50-20', value: 'V_30_50_20' },
          { text: '50-50', value: 'V_50_50' },
          { text: '100%', value: 'V_100' },
          { text: 'Particulares', value: 'V_PARTICULARES' },
        ],
      };
    };
  }
}
